import type { NDateLocale } from './enUS'
import { es } from 'date-fns/locale'

const dateEsES: NDateLocale = {
  name: 'es-ES',
  locale: es
}

export default dateEsES
